import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface GetTcgPlayerMassEntryLinkResponseModel {
	readonly tcgPlayerMassEntryLink: string;
}

export const useOperationTcgPlayerMassEntryLink = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<GetTcgPlayerMassEntryLinkResponseModel>, string> = collectionId => {
		return http<GetTcgPlayerMassEntryLinkResponseModel>({
			method: "GET",
			url: `/collection/${collectionId}/operation/tcg-player-mass-entry`
		});
	};

	return useHTTPMutation({mutationFn});
};
